import { deleteResourceFilterGroup } from '@dispatch/shared/services';
import { useMutation } from 'react-query';

export const useDeleteResourceFilterGroup = (
  userId: string,
  onSuccess: () => void
) => {
  const { mutate, error, status } = useMutation(
    ['delete-resource-filter-group', userId],
    async (groupId: string) => deleteResourceFilterGroup(userId, groupId),
    {
      onSuccess,
    }
  );

  return {
    deleteTaskFilterGroup: mutate,
    error,
    status,
  };
};
